import { render, staticRenderFns } from "./SuppliersCategoriesList.vue?vue&type=template&id=1f17cb82&scoped=true"
import script from "./SuppliersCategoriesList.vue?vue&type=script&lang=js"
export * from "./SuppliersCategoriesList.vue?vue&type=script&lang=js"
import style0 from "./SuppliersCategoriesList.vue?vue&type=style&index=0&id=1f17cb82&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f17cb82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f17cb82')) {
      api.createRecord('1f17cb82', component.options)
    } else {
      api.reload('1f17cb82', component.options)
    }
    module.hot.accept("./SuppliersCategoriesList.vue?vue&type=template&id=1f17cb82&scoped=true", function () {
      api.rerender('1f17cb82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/supplier/categories/views/SuppliersCategoriesList.vue"
export default component.exports